export function safeJsonParse(str) {
  if (!str) return {};
  try {
    return JSON.parse(str);
  } catch {
    console.warn("Invalid JSON:", str);
    return {};
  }
}